// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c2870ef1","963":"6bdd8825"}[chunkId] + ".chunk.js";
};